import { render, staticRenderFns } from "./RegistrationOnlyMapit.vue?vue&type=template&id=76e304ea&scoped=true"
import script from "./RegistrationOnlyMapit.vue?vue&type=script&lang=ts"
export * from "./RegistrationOnlyMapit.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationOnlyMapit.vue?vue&type=style&index=0&id=76e304ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e304ea",
  null
  
)

export default component.exports